module.exports = __webpack_public_path__ + "img/garyMark.5f005892.png";